export enum ApplicationOrderStatus {
    Active = "Active",
    Pending = "Pending",
    Delivered = "Delivered",
}
